import { filter } from 'lodash';
import axios from 'axios';
import { withStyles, createStyles, makeStyles } from '@material-ui/styles';
import { useNavigate } from 'react-router-dom';
import { useState, useEffect } from 'react';
import {
  Card,
  Table,
  TableRow,
  TableBody,
  TableCell,
  Container,
  TableContainer,
  TablePagination,
  Backdrop,
  CircularProgress,
  Box,
  Button,
  IconButton
} from '@material-ui/core';

import moment from 'moment';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import VisibilityIcon from '@material-ui/icons/Visibility';
import Scrollbar from '../Scrollbar';
import SearchNotFound from '../SearchNotFound';
import { baseUrl } from '../../utils/constants';
import { ClientListHead } from '../_dashboard/clients';
import Controls from '../controls/Controls';
import { useClientContext } from '../../context/client_context';
import DependantSub from './DependantSub';
import { useDocumentsContext } from '../../context/document_context';

const useStyles = makeStyles(() => ({
  markVerified: {
    backgroundColor: '#2979ff ',
    color: 'white'
  },
  markUnverified: {
    backgroundColor: '#ff5252',
    color: 'black'
  },
  tableFooter: {
    backgroundColor: 'black',
    color: 'white',
    size: 'small'
  }
}));

const StyledTableRow = withStyles((theme) =>
  createStyles({
    root: {
      '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover
      }
    }
  })
)(TableRow);

const TABLE_HEAD = [
  { id: 'surna', label: 'Surname', alignRight: false },
  { id: 'firstn', label: 'First Name', alignRight: false },
  { id: 'dobs', label: 'Date of Birth', alignRight: true },
  { id: 'str', label: 'Start Date', alignRight: true },
  { id: 'suf', label: 'Suffix', alignRight: false },
  { id: 'gend', label: 'Gender', alignRight: false },
  { id: 'rel', label: 'Relation', alignRight: false },
  { id: 'actions', label: 'Actions', alignRight: true }
];

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function applySortFilter(array, comparator, query) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  if (query) {
    return filter(
      array,
      (_doc) => _doc.documentType.toLowerCase().indexOf(query.toLowerCase()) !== -1
    );
  }
  return stabilizedThis.map((el) => el[0]);
}

export default function DependantsGlo() {
  const { currentClient, dependantList, getDependantsList } = useClientContext();
  const { populateNomDocuments } = useDocumentsContext();
  const [page, setPage] = useState(0);
  const [order, setOrder] = useState('asc');
  const [selected, setSelected] = useState([]);
  //   const [dataList, setDataList] = useState([]);
  const [orderBy, setOrderBy] = useState('documentType');
  const [filterName, setFilterName] = useState('');
  const [loading, setLoading] = useState(false);
  const [openPopup, setOpenPopup] = useState(false);
  const [confirmDialog, setConfirmDialog] = useState({
    isOpen: false,
    title: '',
    subTitle: '',
    heading: '',
    color: '#000000'
  });
  const [rowsPerPage, setRowsPerPage] = useState(6);
  const [notify, setNotify] = useState({ isOpen: false, message: '', type: 'success' });
  const navigate = useNavigate();
  const classes = useStyles();

  useEffect(() => {
    // if (currentClient.cif_number > 0) getDependants();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dependantList]);

  useEffect(() => {
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentClient]);

  //   const getDependants = async () => {
  //     console.log('clientrefid', currentClient);
  //     setLoading(true);
  //     await axios(
  //       `${baseUrl}/api/client/GetDependantsByAfcCifNo?afcNumber=${currentClient.cif_number}&includeMain=false`
  //     ).then(
  //       (res) => {
  //         setDataList(res.data.result);
  //         setLoading(false);
  //       },
  //       (error) => {
  //         notifyPopup(`Failed to retrieve Loans!: ${error}`, 'error');
  //       }
  //     );
  //   };

  const deleteDependant = async (e) => {
    console.log('apa pa 2e iyi:', e);
    if (e === '') {
      return;
    }
    setConfirmDialog({
      ...confirmDialog,
      isOpen: false
    });
    setLoading(true);
    fetch(`${baseUrl}/api/client/DeleteDependant?refId=${e.row.cif_number}`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      }
    })
      .then((res) => res.json())
      .then(
        (result) => {
          setLoading(false);
          if (result.replyStatus === 1) {
            notifyPopup(`Error in Deleting Depandant!: ${result.replyMessage}`, 'error');
          } else {
            notifyPopup(`Dependant Deleted Successfully!`, 'success');
            getDependantsList(e.row.parent_Cif);
          }
        },
        (error) => {
          notifyPopup(`Error in Deleting Depandant!: ${error}`, 'error');
        }
      );
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleDependantView = (e) => {
    console.log('e dependa', e.row.cif_number);
    populateNomDocuments(e.row.cif_number);
    openView(e.row.cif_number);
  };

  const openView = (e) => {
    navigate(`/clientportfolio/editdependant/${e}`);
  };

  const getRelation = (e) => {
    switch (e.relationship_ID) {
      case 0:
        return 'SELF';
      case 1:
        return 'WIFE';
      case 2:
        return 'HUSBAND';
      case 3:
        return 'DAUGHTER';
      case 4:
        return 'SON';
      case 5:
        return 'BROTHER';
      case 6:
        return 'MOTHER';
      case 7:
        return 'FATHER';
      case 8:
        return 'SISTER';
      case 9:
        return 'OTHER';
      case 10:
        return 'SPOUSE';
      default:
        return 'Unknown';
    }
  };

  const getGender = (e) => {
    switch (e.sex_ID) {
      case 0:
        return 'None';
      case 1:
        return 'Male';
      case 2:
        return 'Female';
      case 3:
        return 'Unknown';
      case 4:
        return 'Both';
      default:
        return 'Unknown';
    }
  };

  const notifyPopup = (notifyMessage, notifyType) => {
    setNotify({
      isOpen: true,
      message: `${notifyMessage}`,
      type: `${notifyType}`
    });
  };

  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - dependantList.length) : 0;

  const filteredUsers = applySortFilter(dependantList, getComparator(order, orderBy), filterName);

  const isUserNotFound = filteredUsers.length === 0;

  const handleLoadingClose = () => {
    setLoading(false);
  };

  const closePopup = () => {
    setOpenPopup(false);
    navigate('/dashboard', { replace: true });
  };

  return (
    <Container>
      <Card>
        <Backdrop
          sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={loading}
          onClick={handleLoadingClose}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
        <Scrollbar>
          <TableContainer sx={{ minWidth: 800 }}>
            <Table size="small" aria-label="a dense table">
              <ClientListHead
                order={order}
                orderBy={orderBy}
                headLabel={TABLE_HEAD}
                rowCount={dependantList.length}
                numSelected={selected.length}
                onRequestSort={handleRequestSort}
              />
              <TableBody>
                {filteredUsers
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((row) => {
                    /* eslint-disable camelcase */
                    const {
                      cif_number,
                      surname,
                      firstName,
                      membershipStartDate,
                      dateOfBirth,
                      suffix,
                      sex_ID,
                      relationship_ID
                    } = row;
                    const isItemSelected = selected.indexOf(cif_number) !== -1;

                    return (
                      <StyledTableRow
                        hover
                        key={cif_number}
                        tabIndex={-1}
                        role="checkbox"
                        selected={isItemSelected}
                        aria-checked={isItemSelected}
                      >
                        <TableCell padding="checkbox" />
                        <TableCell align="left">{surname}</TableCell>
                        <TableCell align="left">{firstName}</TableCell>
                        <TableCell align="right" component="th" scope="row" padding="none">
                          {moment(dateOfBirth).isValid()
                            ? moment(dateOfBirth).format('YYYY-MM-DD')
                            : ''}
                        </TableCell>
                        <TableCell align="right" component="th" scope="row" padding="none">
                          {moment(membershipStartDate).isValid()
                            ? moment(membershipStartDate).format('YYYY-MM-DD')
                            : ''}
                        </TableCell>
                        <TableCell align="left">{suffix}</TableCell>
                        <TableCell align="left">{getGender({ sex_ID })}</TableCell>
                        <TableCell align="left">{getRelation({ relationship_ID })}</TableCell>
                        <TableCell align="right">
                          <IconButton onClick={() => handleDependantView({ row })}>
                            <VisibilityIcon sx={{ color: '#03a9f4' }} />
                          </IconButton>
                          <IconButton
                            onClick={() =>
                              setConfirmDialog({
                                isOpen: true,
                                title: 'Are you sure you want to Delete Dependant',
                                subTitle: "You can't undo this action",
                                heading: 'Delete Dependant',
                                color: '#00000',
                                onConfirm: () => {
                                  deleteDependant({ row });
                                }
                              })
                            }
                          >
                            <DeleteForeverIcon sx={{ color: '#f50057' }} />
                          </IconButton>
                        </TableCell>
                        {/* <TableCell align="right">
                          {Number(sessionStorage.getItem('userRefId')) < 10 && (
                            <TableCell>
                              <IconButton
                                onClick={() =>
                                  setConfirmDialog({
                                    isOpen: true,
                                    title: 'Are you sure you want to Delete Document',
                                    subTitle: "You can't undo this action",
                                    heading: 'Delete Document',
                                    color: '#00000',
                                    onConfirm: () => {
                                      deleteDependant({ row });
                                    }
                                  })
                                }
                              >
                                <DeleteForeverIcon sx={{ color: '#f50057' }} />
                              </IconButton>
                            </TableCell>
                          )}
                        </TableCell> */}
                      </StyledTableRow>
                    );
                  })}
                {emptyRows > 0 && (
                  <TableRow style={{ height: 53 * emptyRows }}>
                    <TableCell colSpan={6} />
                  </TableRow>
                )}
              </TableBody>
              {isUserNotFound && (
                <TableBody>
                  <TableRow>
                    <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                      <SearchNotFound searchQuery={filterName} />
                    </TableCell>
                  </TableRow>
                </TableBody>
              )}
            </Table>
          </TableContainer>
          <Controls.Notification notify={notify} setNotify={setNotify} />
          <Controls.ConfirmDialog
            confirmDialog={confirmDialog}
            setConfirmDialog={setConfirmDialog}
          />
        </Scrollbar>

        <TablePagination
          className={classes.tableFooter}
          rowsPerPageOptions={[6, 12, 18]}
          component="div"
          count={dependantList.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Card>
    </Container>
  );
}
